import * as React from 'react';
import {Helmet} from 'react-helmet';

import {createPeanutScript} from '../../util/peanut-script';

import styles from './peanut-scheduler.module.css';

type ViewType = 'interactive' | 'static' | 'schedule';

type Props = {
    schedulerConfig: string;
    meetingModelId: number;
    instanceId?: string;
    viewType?: ViewType;
};

export function PeanutScheduler(props: Props) {
    const {viewType = 'static'} = props;

    const target = `ns-scheduler-${props.meetingModelId}`;
    const scriptRef = React.createRef();

    React.useEffect(() => {
        if (props.schedulerConfig) {
            const script = createPeanutScript(String(props.meetingModelId));
            script.setAttribute('meeting-id', `${props.meetingModelId}`);
            script.setAttribute(
                'instance-id',
                props.instanceId || NutshellFrontendSettings.instanceId
            );
            script.setAttribute('target', target);
            script.setAttribute('view-type', viewType);
            script.setAttribute('scheduler-config', props.schedulerConfig);

            if (scriptRef && scriptRef.current) {
                // @ts-expect-error
                scriptRef.current.appendChild(script);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.schedulerConfig]);

    return (
        <>
            <Helmet>
                <meta name='viewport' content='width=device-width,initial-scale=1' />
            </Helmet>
            <div
                id={target}
                className={
                    viewType === 'static'
                        ? styles['peanut-scheduler-preview--static']
                        : styles['peanut-scheduler-preview']
                }
            />
            {/* @ts-expect-error */}
            <div ref={scriptRef} />
        </>
    );
}
